export enum IssueTrackingRequestTypes {
  GetProductTeamsFailure = 'IssueTracking.GetProductTeams.Failure',
  GetProductTeamsRequest = 'IssueTracking.GetProductTeams.Request',
  GetProductTeamsSuccess = 'IssueTracking.GetProductTeams.Success',
  CreateIssueFailure = 'IssueTracking.CreateIssue.Failure',
  CreateIssueRequest = 'IssueTracking.CreateIssue.Request',
  CreateIssueSuccess = 'IssueTracking.CreateIssue.Success',
}
